// TODO: Refactor after Drift Subscription implementation — added on 22–05–2023 by algeas
export const ecommerceOnlyBrands = [
  'drift',
]
